export default "__VITE_ASSET__CzIip3pP__"